import { EticketPortalMixer } from '@linktivity/gds-next';
import fetch from '../fetch';

const eticketPortal = new EticketPortalMixer(fetch);

export default eticketPortal;
